import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { UserContext } from "./App";
import { StateBoxProps } from "./HSM";
import HSMRenderer, { HSMRendererProps, HSMView, HSMViewProps, ToolBar } from "./HSMRenderer.tsx";
import { getNewStateProps } from "./utils/stateUtils.tsx";

export type ActivityProps = {
    name : string;
    attributes : string[];
    url : string;
}

export const Activity = ({
    name,
    attributes,
    url,
} : ActivityProps) => {
    function viewWorkflow() {
        window.open(url, "_self");
    }

    const WorkflowsIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" fill="currentColor">
                <path d="M2 2v4h4V2H2zm0-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm12 0h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v4h4V2h-4zm0 10h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 2v4h4v-4h-4zM2 12h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm0 2v4h4v-4H2z">
                </path>
            </svg>
        );
    }

    // let attributesElts = attributes.map((str) => <p>{str}</p>);
    console.log(attributes);
    return (
            <div className='activity'>
                <h3>{name}</h3>
                <div className='activity-content'>
                    <h4>Attributes</h4>
                    <p>{attributes}</p>
                    {/* {attributesElts} */}
                    <button className='btn btn-light' onClick={() => viewWorkflow()}>
                        <div className='btn-contents'>
                            <WorkflowsIcon/>
                            <div className='btn-text'>
                                <b>Open workflow</b>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
    );
}

export type ADLProps = {
    name : string;
    avatar : string;
    newWorkflowBtn : boolean;
    userContext : UserContext
    children ?: JSX.Element | JSX.Element[];
}

export const ADL = ({
    name,
    avatar,
    newWorkflowBtn,
    userContext,
    children=[],
} : ADLProps) => {
    function createNewWorkflow(callBackFn : (value:Response) => void | PromiseLike<void>) {
        // insert new HSM into edit db
        let newStateProps = getNewStateProps(() => 1, 3, (x) => {}, [2], (x) => {}, (x) => {});
        const viewMode = userContext.occupation === 'Roboticist' ? 'robot' : 'human';
        let newActivityProps = {text:'Untitled workflow', id: 2, author: userContext.id, adl:name, children:[newStateProps], avatar:avatar, viewMode: viewMode};
    
        fetch(`http://34.74.45.28:8080/hsm_edit/`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(newActivityProps)
        }).then(callBackFn);
    }

    function onWorkflowMade(res:Response) {
        res.json().then((data) => {
            window.open("http://sparcs-box-342816.uk.r.appspot.com/edit/" + data._id);
        });
    }

    const FeedingIcon = () => {
        const dressingIcon = <span className="material-icons">checkroom</span>;
        const bathingIcon = <span className="material-icons">bathtub</span>;
        const diningIcon = <span className="material-icons">dining</span>;
        const transferingIcon = <span className="material-icons">bed</span>;

        let icon;

        switch(name) {
            case 'Dressing':
                icon = dressingIcon;
                break;
            case 'Bathing':
                icon = bathingIcon;
                break;
            case 'Feeding':
                icon = diningIcon;
                break;
            case 'Transferring':
                icon = transferingIcon;
                break;
            default:
                icon = null;
                break;
        }
        return icon;
    }

    const PlusIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-4.5 -4.5 24 24" width="24" fill="currentColor">
                <path d="M8.9 6.9v-5a1 1 0 1 0-2 0v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5z">
                </path>
            </svg>
        );
    }

    return (
        <div className='adl'>
            <h1><span className='adl-icon'><FeedingIcon/></span>{name}</h1>
            <div className='adl-content'>
                {children}
                {newWorkflowBtn && <button className='btn btn-success mb-3' onClick={() => createNewWorkflow(onWorkflowMade)}>
                        <div className='btn-contents'>
                            <PlusIcon/>
                            <div className='btn-text'>
                                <b>New workflow</b>
                            </div>
                        </div>
                </button>}
            </div>
        </div>
    );
}

export type ADLsProps = {
    userContext: UserContext;
    setCursor: React.Dispatch<React.SetStateAction<string>>;
}

// let adlElts = [];
let adlElts = [];
let adls = [];
let adlsEdit = [];
let avatarName;

export const ADLs = ({
    userContext,
    setCursor,
} : ADLsProps) => {
    const [adlsLoaded, setAdlsLoaded] = useState(false);
    const {avatar} = useParams();

    useEffect(() => {
        async function getAdls() {
            adls = [];
            const response = await fetch(`http://34.74.45.28:8080/adls/` + avatar);
            const response2 = await fetch(`http://34.74.45.28:8080/adls_edit/` + avatar + `/` + userContext.id);
            const avatarResponse = await fetch(`http://34.74.45.28:8080/avatar/` + avatar);

            if (!response.ok || !response2.ok || !avatarResponse.ok) {
                const message = `An error occured: ${response.statusText}`;
                window.alert(message);
                return;
            }

            const adlsRes = await response.json();
            const adlsEditRes = await response2.json();
            const avatarRes = await avatarResponse.json();

            adlsRes.forEach(adlObj => {
                let activityProps = [];
            
                adlObj.children.forEach(hsmObj => {
                    const atts = {
                        "Object(s)": "hey",
                        "User position": "Supine on bed",
                    }
                    // console.log(JSON.parse(JSON.stringify(atts)));
                    let attsArr = [];

                    for (const [key, value] of Object.entries(JSON.parse(hsmObj.attributes))) {
                        console.log(key, value);
                        attsArr.push(<b>{`${key}: `}</b>);
                        attsArr.push(`${value}`);
                        attsArr.push(<br/>);
                    }
                    // console.log(hsmObj);
                    activityProps.push({
                        name : hsmObj.text,
                        attributes : attsArr,
                        url : '/view/' + hsmObj._id,
                    });
                });

                activityProps = activityProps.map((props) => <Activity {...props}/>);
                adls.push({name: adlObj.name, children:activityProps});
            });

            adlsEditRes.forEach(adlObj => {
                let activityProps = [];
            
                adlObj.children.forEach(hsmObj => {
                    activityProps.push({
                        name : hsmObj.text,
                        attributes : ['User position: supine'],
                        url : '/edit/' + hsmObj._id,
                    });
                });

                activityProps = activityProps.map((props) => <Activity {...props}/>);
                adlsEdit.push({name: adlObj.name, children:activityProps});
            });
            
            avatarName = avatarRes.name;
            setAdlsLoaded(true);
        }

        getAdls();
    }, [adlsLoaded]);

    let listItems = adls.map((obj) => {
            return <ADL {...obj} userContext={userContext} avatar={avatar} newWorkflowBtn={false}/>
        }
    );

    let myListItems = adlsEdit.map((obj) => {
        return <ADL {...obj} userContext={userContext} avatar={avatar} newWorkflowBtn={true}/>
    }
);

    if(!adlsLoaded) {
        return null;
    }

    return (
        <div>
            <div className='container-md mb-5'>
                <div className='row'>
                    <div className="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
                        <h1 className='header'>Public workflows for {avatarName}</h1>
                    </div>
                </div>
            </div>
            <div className='ADLsViewer'>
                {listItems}
            </div>
            <div className='container-md mb-5'>
                <div className='row'>
                    <div className="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
                        <h1 className='header'>My workflows for {avatarName}</h1>
                    </div>
                </div>
            </div>
            <div className='ADLsViewer'>
                {myListItems}
            </div>
        </div>
        
    );
}

export default ADLs;
